<template>
  <div class="chart">
    <p>{{ content }}</p>
    <div class="header">
      <div class="logo">
        <img src="@/assets/images/logoChart.png" alt="" />
      </div>
      <div class="detial">
        <p>北京智胜远景科技有限公司正在为您服务</p>
        <p>010-68888687</p>
      </div>
    </div>
    <div class="container">
      <div class="left">
        <div class="left-top">
          <div class="left-top-container">
            <ul>
              <li class="question">
                <span>系统客服 2022.6.6 13.12.25</span>
                <p>你的问题是什么</p>
              </li>
              <li class="answer">
                <span>我 2022.6.6 13.12.25</span>
                <p>暂时没</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="left-bottom">
          <textarea
            name=""
            id=""
            cols="60"
            rows="7"
            v-model="content"
            class="content"
          ></textarea>

          <el-button type="primary" size=" medium " class="send"
            >发送</el-button
          >
        </div>
      </div>
      <div class="right">
        <img src="@/assets/images/6.jpg" alt="" />
        <p>北京智胜远景公司北京智胜远景公司北京智胜远景公司北京智胜远景公司</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: "",
    };
  },
};
</script>

<style lang="less" scoped>
.chart {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 8px 40px 0 rgba(0, 0, 0, 0.2);
  border-radius: 0.08rem;
  overflow: hidden;
  .header {
    display: flex;
    width: 100%;
    height: 0.6rem;
    background-color: #6696ff;
    padding-left: 0.15rem;
    padding-right: 0.15rem;
    box-sizing: border-box;
    .logo {
      width: 0.3rem;
      height: 0.3rem;
      border-radius: 50%;
      margin-top: 0.1rem;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .detial {
      color: #fff;
      margin-left: 0.15rem;
      margin-top: 0.1rem;
      p {
        padding-bottom: 0.05rem;
      }
    }
  }
  .container {
    display: flex;
    .left {
      flex: 1;
      .left-top {
        height: 4.1rem;
        width: 5.6rem;
        overflow: auto;
        .left-top-container {
          height: 16rem;
          ul {
            padding: 0.1rem;
            span {
              display: block;
              margin-bottom: 4px;
              font-size: 12px;
              line-height: 12px;
              color: #a4a0aa;
            }
            .question {
              display: inline-block;
              p {
                float: left;
                text-align: left;
                border-radius: 0 8px 8px 8px;
                background-color: rgba(100, 147, 252, 0.16);
                padding: 12px;
              }
            }
          }
          .answer {
            text-align: right;
            p {
              float: right;
              border-radius: 8px 0 8px 8px;
              background-color: rgba(100, 147, 252, 0.16);
              padding: 12px;
            }
          }
        }
      }
      .left-bottom {
        position: relative;
        border-top: 1px solid #ebeef5;
        width: 560px;
        height: 130px;
        .send {
          position: absolute;
          bottom: 20px;
          right: 10px;
        }

        .content {
          box-sizing: border-box;
          padding: 10px;
          border: none;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          -webkit-user-modify: read-write-plaintext-only;
          outline: none;
          box-shadow: none;
        }
      }
    }
    .right {
      width: 240px;
      height: 540px;
      border-left: 1px solid #ebeef5;
      img {
        width: 200px;
        height: 250px;
        margin-left: 20px;
        margin-top: 20px;
      }
      p {
        padding: 10px;
        text-indent: 2em;
      }
    }
  }
}
</style>